// TeamRow.js
import React from 'react';
import PlayerIdentity from '../../shared/PlayerIdentity';
import droppedIcon from '../../shared/assets/bin.png';
import MarketValueCell from './MarketValueCell';

const DroppedPlayerRow = ({ player }) => {

    return (
      <tr>

        <td className="name-td">
            <div className="flex-container">
            <PlayerIdentity player={player} icon={droppedIcon} />
            </div>
        </td>      

        <td>{player.salary}</td>
        <MarketValueCell value={player.auction_value} />
        <td>{player.contract_length}</td>
        <td>{player.cap_penalty}</td>

      </tr>
    );
  };
  
  export default DroppedPlayerRow;
